import { useRouter } from '@/i18n/navigation'
import type { EnterpriseCheckoutRoute, PrivateCheckoutRoute } from '@/shared/routes'

type PropsUsePurchaseFlowNavigation = {
  /**
   * Set to true if the sales flow is related to B2B
   */
  isEnterprise: boolean
}

export const usePurchaseFlowNavigation = ({ isEnterprise }: PropsUsePurchaseFlowNavigation) => {
  const router = useRouter()

  const navigateNextPage = (
    route: PrivateCheckoutRoute,
    enterpriseRoute: EnterpriseCheckoutRoute,
  ) => {
    router.push({ pathname: isEnterprise ? enterpriseRoute : route })
  }

  return navigateNextPage
}
